<template>
  <div class="b-settings__block p-6 pb-8">
    <h2 class="mb-4">{{$t('CONTENT.settingsPage.credentials')}}</h2>
    <div v-if="error" class="mb-2">
      <server-error :error="error" />
    </div>
    <form v-if="isLoaded" class="b-form p-0" @submit.prevent="onSubmit">
      <div class="b-settings__block-box row row-no-flex">
        <div class="col-3">
          <div class="b-form__container">
            <label>{{$t('CONTENT.settingsPage.system_owner')}}:</label>
          </div>
        </div>
        <div class="row mx-0 b-form__row_type_flex-end">
          <div class="col-5 pr-2" data-cy="contract-setting-yearsToAddToPerpetuity">
            <cool-select :list="counterparties"
                         :isDisabled="isReadOnlyMode"
                         option-value="id"
                         option-text="value"
                         :placeholder="$t('CONTENT.choose')"
                         v-model="currentCounterpartyId"></cool-select>
          </div>
          <div class="pr-2">
            <button
              v-if="!isReadOnlyMode"
              type="button"
              data-cy="create-new-asset"
              class="b-btn b-btn_type_add"
              @click="openCounterPartyDialog"
            >
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
            </button>
          </div>
          <button
            v-if="!isReadOnlyMode"
            type="button"
            data-cy="create-new-asset"
            class="b-btn b-btn_type_add"
            @click="openImportDialog"
          >
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="xls"></dynamic-icon>
          </button>
        </div>
        <div class="col-6 mt-2">
          <div class="b-settings__block-note">{{$t('CONTENT.settingsPage.system_owner_note')}}</div>
        </div>
      </div>
      <button
        v-if="!isReadOnlyMode"
        class="b-btn b-btn_type_primary mt-4"
        type="submit"
        data-cy="next-step"
        :disabled="isDisabledSaveBtn"
      >{{$t('CONTENT.save')}}</button>
    </form>
    <popup name="counterparty-owner-popup" height="auto" :scrollable="true">
      <server-error :error="error" />
      <GeneralForm
        v-if="isCounterPartyShow"
        :counterparty="counterpartyForForm"
        :counterpartyVatHistoryList="counterpartyVatHistoryList"
        @createNewCounterparty="onCreateCounterparty($event)"
        @openVatSettings="openVatSettings"
        @close="closeCounterPartyDialog"
      />
    </popup>
    <popup name="vat-settings-owner-popup" height="auto" :scrollable="true">
      <VatSettingsForm
        v-if="isVatSettingsOpen"
        :rates="counterpartyVatHistoryList"
        :counterparty-type-id="counterpartyForForm ? counterpartyForForm.idInDB : null"
        :is-create="!counterpartyForForm || !counterpartyForForm.idInDB"
        @close="closeVatSettings"
        @saveVatRates="updateVatRates"
      />
    </popup>
    <popup name="counterparty-owner-import-popup" height="auto" :scrollable="true">
      <ImportDialogWidget :importType="'counterparty'" v-if="isShowImportDialog" @close="closeImportDialog"></ImportDialogWidget>
    </popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ImportDialogWidget from "../widgets/ImportDialogWidget";
import GeneralForm from "../directories/counterparty/edit/GeneralForm";
import VatSettingsForm from "../directories/counterparty/edit/VatSettingsForm";

export default {
  components: {
    ImportDialogWidget,
    GeneralForm,
    VatSettingsForm,
  },
  props: {
    isReadOnlyMode: {
      type: Boolean
    },
  },
  data() {
    return {
      error: null,
      systemOwnerCounterpartyId: null,
      isDisabledSaveBtn: true,
      isShowImportDialog: false,
      isCounterPartyShow: false,
      counterpartyForForm: null,
      isVatSettingsOpen: false,
      counterpartyVatHistoryList: [],
    }
  },
  computed: {
    ...mapGetters(["getCounterpartiresForContract"]),
    ...mapGetters(['getContractSettings']),
    counterparties() {
      return this.getCounterpartiresForContract;
    },
    currentCounterpartyId: {
      get() {
        if(this.systemOwnerCounterpartyId === null) {
          this.systemOwnerCounterpartyId = this.getContractSettings.systemOwnerCounterpartyId;
        }

        return this.systemOwnerCounterpartyId;
      },
      set(newVal) {
        this.systemOwnerCounterpartyId = newVal;
        this.isDisabledSaveBtn = false;
      }
    }
  },
  methods: {
    async closeImportDialog() {
      this.setNewCounterparty();
      this.isDisabledSaveBtn = false;
      this.isShowImportDialog = false;
      this.$modal.hide('counterparty-owner-import-popup');
    },
    openImportDialog() {
      this.isShowImportDialog = true;
      this.$modal.show('counterparty-owner-import-popup');
    },
    openCounterPartyDialog() {
      this.counterpartyVatHistoryList = [];
      this.isCounterPartyShow = true;
      this.$modal.show('counterparty-owner-popup');
    },
    closeCounterPartyDialog() {
      this.isCounterPartyShow = false;
      this.counterpartyForForm = null;
      this.$modal.hide('counterparty-owner-popup');
    },
    openVatSettings() {
      this.isVatSettingsOpen = true;
      this.$modal.show('vat-settings-owner-popup');
    },
    closeVatSettings() {
      this.isVatSettingsOpen = false;
      this.$modal.hide('vat-settings-owner-popup');
    },
    updateVatRates(rates) {
      this.counterpartyVatHistoryList = rates;
    },
    async onCreateCounterparty() {
      this.setNewCounterparty();
      this.isDisabledSaveBtn = false;
    },
    async setNewCounterparty() {
      await this.$store.dispatch('getAllCounterparties');
      this.systemOwnerCounterpartyId = this.getCounterpartiresForContract[0].id;
    },
    async onSubmit() {
      try {
        this.error = null;
        this.$loadingManager.addLoadingStep();
        await this.$store.dispatch('setContractSettings', {systemOwnerCounterpartyId: this.systemOwnerCounterpartyId});
        this.isDisabledSaveBtn = true;
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    }
  }
}
</script>

<style scoped>

</style>
